"use strict";
/* EXPORT */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./methods"));



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/index.js
// module id = 2170
// module chunks = 0